<template>
<div class="chapter">
<div class="inner_page">
<p class="C671"><strong><a id="page_1">I</a></strong></p><a id="page_1">
<p class="C662"><em>Openings</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_ONE__Openings.vue?06b856dc